<template>
  <main class="admin-page">
    <header class="page-heading"><div><div class="page-kicker">PEOPLE</div><h1 class="page-title">用户与婚影师</h1><p class="page-lead">查看账号身份、实名状态和婚影师入驻状态，账号限制必须保留处理记录。</p></div><el-button icon="el-icon-refresh" @click="load">刷新</el-button></header>
    <section class="surface"><el-table :data="list" empty-text="暂无用户数据">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="phone" label="手机号" />
      <el-table-column prop="role" label="角色" />
      <el-table-column prop="realname_status" label="实名状态" />
      <el-table-column prop="creator_verify_status" label="创作者认证" />
      <el-table-column prop="status" label="账号状态" />
      <el-table-column label="操作" width="220">
        <template slot-scope="{ row }">
          <el-button v-if="row.status === 'active'" size="mini" type="danger" @click="setStatus(row, 'banned')">封禁</el-button>
          <el-button v-else-if="row.status === 'banned'" size="mini" @click="setStatus(row, 'active')">解封</el-button>
          <el-tag v-else size="mini" type="info">已注销</el-tag>
          <el-button size="mini" type="danger" plain :disabled="deleting === row.id" @click="removeUser(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table></section>
  </main>
</template>

<script>
import request from '../api/request'
import ElTable from 'element-ui/lib/table'
import ElTableColumn from 'element-ui/lib/table-column'
import ElTag from 'element-ui/lib/tag'

export default {
  components: { ElTable, ElTableColumn, ElTag },
  data() {
    return { list: [], deleting: null }
  },
  created() {
    this.load()
  },
  methods: {
    async removeUser(row) {
      let reason
      try {
        const result = await this.$prompt(`删除用户 #${row.id}（${row.nickname || row.phone || '微信用户'}）将清除个人资料、下架其邀请及作品，并清理上传素材。交易和操作记录保留。进行中项目或未结款项会阻止删除。请输入删除原因：`, '删除用户', {
          confirmButtonText: '确认删除', cancelButtonText: '取消', inputType: 'textarea',
          inputValidator: value => (String(value || '').trim().length >= 5 && String(value || '').length <= 500) || '请填写 5 至 500 字的原因'
        })
        reason = result.value
      } catch (_) { return }
      this.deleting = row.id
      try {
        const result = await request.delete(`/users/${row.id}`, { data: { reason } })
        this.$message[result.cleanupPending ? 'warning' : 'success'](result.cleanupPending ? '用户已删除，部分文件等待自动重试清理' : '用户资料与上传素材已删除')
        await this.load()
      } catch (_) { /* request interceptor displays API errors */ } finally { this.deleting = null }
    },
    async load() {
      const res = await request.get('/users')
      this.list = res.list
    },
    async setStatus(row, status) {
      await request.patch(`/users/${row.id}/status`, { status })
      this.$message.success('已更新')
      this.load()
    }
  }
}
</script>
